const getAppName = () => {
  const appName = 'Cxqnmv7LmxpMxGXywOcs';
  return appName;
};

export default getAppName;